module.exports = __webpack_public_path__ + "d35468e70047afb9bd86ac00dba2a561.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/school-scene.svg
// module id = 1472
// module chunks = 4